import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ReactElement } from "react";

export const ProtectedRoute = ({ children }: { children: ReactElement }) => {
  useAuth();
  const location = useLocation();
  const token = localStorage.getItem("accessToken");
  if (!token) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}${location.hash}` }}
      />
    );
  }
  return children;
};